import React from 'react';
import { motion } from 'framer-motion';
import { MousePointer, Settings, CreditCard, Smartphone } from 'lucide-react';

const HowItWorksSection = () => {
  const steps = [
    {
      icon: MousePointer,
      title: 'Vyberete typ výzvy',
      description: 'Zvolíte párovou nebo rozlučkovou variantu.',
    },
    {
      icon: Settings,
      title: 'Nastavíte parametry',
      description: 'Vyberete obtížnost, velikost balíčku a další možnosti.',
    },
    {
      icon: CreditCard,
      title: 'Provedete platbu',
      description: 'Bezpečně online přes platební bránu.',
    },
    {
      icon: Smartphone,
      title: 'Obdržíte balíček',
      description: 'Okamžitě získáte přístup k zakoupené výzvě.',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-semibold text-[var(--vp-ink)] mb-4">
            Jak to funguje
          </h2>
          <p className="text-[var(--vp-ink)]/70 max-w-2xl mx-auto">
            Od výběru až po první výzvu za pár minut.
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {steps.map((step, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="relative"
            >
              <motion.div
                whileHover={{ y: -5, boxShadow: 'var(--shadow-lift)' }}
                transition={{ type: 'spring', stiffness: 300 }}
                className="bg-white rounded-2xl p-6 border border-[var(--vp-line)] h-full"
              >
                <div className="step-number mb-4">
                  {index + 1}
                </div>
                <motion.div
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  className="w-12 h-12 rounded-xl bg-[var(--vp-sand)] flex items-center justify-center mb-4"
                >
                  <step.icon className="w-6 h-6 text-[var(--vp-pink)]" />
                </motion.div>
                <h3 className="text-lg font-semibold text-[var(--vp-ink)] mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-[var(--vp-ink)]/70">
                  {step.description}
                </p>
              </motion.div>
              
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-0.5 bg-[var(--vp-line)]" />
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
